import { type components } from '@depop/types-presentation-default-snowdon-api';

export type PriceEstimate = components['schemas']['PriceEstimate'];
export type PriceBreakdown = components['schemas']['PriceEstimateBreakdown'];
export type PriceEstimateAmount =
  components['schemas']['PriceEstimateBreakdownPrice'];

export type TotalPriceComponents = {
  buyer_fee: boolean;
  shipping_price: boolean;
  tax: boolean;
};

export type DisplayPrice = components['schemas']['DisplayPrice'];
export type DisplayPriceElement = components['schemas']['DisplayPriceElement'];
export type HeadlinePriceComponents =
  components['schemas']['HeadlinePriceComponents'];
export type SecondaryPrice = components['schemas']['SecondaryPrice'];
export type SecondaryPriceTypeValue = SecondaryPrice['type'];

export const SecondaryPriceType = {
  ShippingCost: 'SHIPPING_COST',
  DynamicText: 'DYNAMIC_TEXT',
} as const satisfies Record<string, SecondaryPriceTypeValue>;
